<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div class="topBack" />
    <div class="topImage">
      <van-swipe :autoplay="5000" class="images">
        <van-swipe-item v-for="(image, index) in images" :key="index">
          <img :src="image">
        </van-swipe-item>
      </van-swipe>
    </div>
    <div v-if="data && data.isSelf" style="padding:0 1em;">
      <van-row gutter="10">
        <van-col span="8"><van-button type="primary" style="width:100%" :color="GetColorMainBack()" :loading="buttonLoading" @click="onViewBaseCard">查看标准卡</van-button></van-col>
        <van-col span="8"><van-button type="primary" style="width:100%" :color="GetColorSecondary()" :loading="buttonLoading" @click="onChangeFace"> 更换卡面</van-button></van-col>
        <van-col span="8"><van-button type="primary" style="width:100%" :color="GetColorMainBack()" :loading="buttonLoading" @click="onBuyCard">购买实体卡</van-button></van-col>
      </van-row>
    </div>
    <div v-if="data" class="infoRect">
      <van-row>
        <van-col span="18">
          <div class="title">
            {{ data.isSelf?'我的资料 /MY INFORMATION':'TA的资料 /INFORMATION' }}
          </div>
          <div class="body">
            <template v-if="data.groupTeam==='AIDA'">
              <van-row>
                <van-col span="12">姓名 Name:</van-col>
                <van-col span="12">{{ data.firstName }}</van-col>
              </van-row>
            </template>
            <template v-else>
              <van-row>
                <van-col span="12">姓 Last name:</van-col>
                <van-col span="12">{{ data.lastName }}</van-col>
              </van-row>
              <van-row>
                <van-col span="12">名 First name:</van-col>
                <van-col span="12">{{ data.firstName }}</van-col>
              </van-row>
            </template>
            <van-row>
              <van-col span="12">生日 Birthday:</van-col>
              <van-col span="12">{{ data.birthdayStr }}</van-col>
            </van-row>
          </div>
        </van-col>
        <van-col span="6"><img class="headIcon" :src="data.headIcon?data.headIcon:'/img/defaultUserIcon.jpg'">
        </van-col>
      </van-row>
    </div>
    <div v-if="data" class="infoRect">
      <div class="title">
        证书信息 /CERTIFICATION
      </div>
      <div class="body">
        <van-row>
          <van-col span="9">组织 Organization:</van-col>
          <van-col span="15">{{ data.groupTeam==='OTHER'?data.groupTeamName:data.groupTeam }}</van-col>
        </van-row>
        <van-row>
          <van-col span="9">证书 Name:</van-col>
          <van-col span="15">{{ data.cerificateName }}</van-col>
        </van-row>
        <van-row>
          <van-col span="9">编号 License Id:</van-col>
          <van-col span="15">{{ data.cerificateId }}</van-col>
        </van-row>
        <van-row>
          <van-col span="9">签发日期 Date:</van-col>
          <van-col span="15">{{ data.certificateDate?formatDate(data.certificateDate,"yyyy/MM/dd"):'-' }}</van-col>
        </van-row>
      </div>
    </div>
    <div v-if="data" class="infoRect">
      <div class="title">
        潜店信息 /DIVE CENTER
      </div>
      <div class="body">
        <van-row v-if="data.divecenterName">
          <van-col span="9">中心 Center:</van-col>
          <van-col span="15">{{ data.divecenterName }}</van-col>
        </van-row>
        <van-row v-if="data.divecenterID">
          <van-col span="9">中心编号 Center Id:</van-col>
          <van-col span="15">{{ data.divecenterID }}</van-col>
        </van-row>
        <van-row v-if="data.instructorName">
          <van-col span="9">教练 Instructor:</van-col>
          <van-col span="15">{{ data.instructorName }}</van-col>
        </van-row>
        <van-row v-if="data.instructorID">
          <van-col span="9">教练编号 Ins Id:</van-col>
          <van-col span="15">{{ data.instructorID }}</van-col>
        </van-row>
      </div>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Swipe, SwipeItem } from 'vant'
import TopBar from '@/components/TopBar'
import { MyNotify, ShowMoney, GetEnumText, formatDate, UrlBase64 } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import { getToken } from '@/utils/auth'
export default {
  components: {
    [Button.name]: Button,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    TopBar
  },
  data() {
    return {
      titleTop: '',
      title: '我的卡片',
      backurl: '/store/index',
      code: undefined,
      data: undefined,
      images: [],
      buttonLoading: false
    }
  },

  created() {
    this.titleTop = GetSysTitle()
    this.code = this.$route.params.code
    this.init()
  },
  methods: {
    MyNotify,
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    init() {
      request({
        url: '/user/getUserOneCertificate',
        method: 'post',
        params: { code: this.code }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.data = response.data
        this.title = this.data.isSelf ? '我的卡片' : this.data.firstName.toUpperCase() + '的卡片'
        this.images = []
        var tStr = '&k=' + this.data.faceKey
        if (this.data.image) {
          if (this.data.image.indexOf('.jpg') < 0 && this.data.image.indexOf('.png') < 0) {
            this.images.push(this.data.image + tStr + '&token=' + UrlBase64(getToken()))
          } else {
            this.images.push(this.data.image)
          }
        }
        if (this.data.imageBack) {
          if (this.data.imageBack.indexOf('.jpg') < 0 && this.data.imageBack.indexOf('.png') < 0) {
            this.images.push(this.data.imageBack + tStr + '&token=' + UrlBase64(getToken()))
          } else {
            this.images.push(this.data.imageBack)
          }
        }
        if (!this.data.imageBack && this.data.imageBackPro) {
          if (this.data.imageBackPro.indexOf('.jpg') < 0 && this.data.imageBackPro.indexOf('.png') < 0) {
            this.images.push(this.data.imageBackPro + tStr + '&token=' + UrlBase64(getToken()))
          } else {
            this.images.push(this.data.imageBackPro)
          }
        }
        this.images = JSON.parse(JSON.stringify(this.images))
      })
    },
    onChangeFace() {
      this.$router.push('/my/myCerificateFace/' + this.data.userCertificateVirtualId)
    },
    onViewBaseCard() {
      if (this.data.groupTeam !== 'AIDA') {
        MyNotify('info', this.data.groupTeam + '暂不支持查看基本卡!')
        return
      }
      this.$router.push('/my/basicCardView/' + this.data.userCertificateVirtualId)
    },
    onBuyCard() {
      this.buttonLoading = true
      request({
        url: '/user/userCertificateFaceSelect',
        method: 'post',
        data: { userCertificateVirtualId: this.data.userCertificateVirtualId,
          justGetCommodityId: true
        }
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        if (response.data) {
          var url = '/store/item/' + response.data.commodityId +
          '?SpecificationId=' + response.data.specificationId +
          '&certificateId=' + this.data.userCertificateId
          this.$router.push(url)
        } else {
          this.onChangeFace()
        }
      })
    }
  }
}
</script>
<style scoped>
.topBack{
  margin-top: 3em;
  height: 12em;

  position: absolute;
  top: 0;
  left: 0;
  right: 0;
    background-image: linear-gradient(0, #555, #000);
}
.topImage{
margin: 0.5em 1em;
border-radius: 0.5em;
max-height: 70vw;
overflow: hidden;
}
.topImage .images{
  width: 100%;
}
.topImage .images img{
  width: 100%;
  border-radius: 0.5em;
  min-height: 60vw;
}
.infoRect{
  margin: 1em;
  border-bottom: 1px solid #ccc;
  padding:1em 0;
}
.infoRect .title{
  color: #000;
  font-size: 1.1em;
  font-weight: 700;
  padding-bottom: 1em
}
.infoRect .body{
  color: #999;
  line-height: 1.6em;
  font-size: 0.9em;
}
.headIcon{
  width: 100%;
}
</style>
